import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { PhxDropListComponent } from './drop-list/phx-drop-list.component';
import { PhxDragItemComponent } from './drag-items/base/phx-drag-item.component';
import { PhxDragItemCardComponent } from './drag-items/card/phx-drag-item-card.component';
import { PhxDragItemInlineComponent } from './drag-items/inline/phx-drag-item-inline.component';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxDragHandleComponent } from './drag-handle/phx-drag-handle.component';
import { PhxIconModule } from '../icon/icon.module';

@NgModule({
  declarations: [PhxDropListComponent, PhxDragItemComponent, PhxDragItemCardComponent, PhxDragItemInlineComponent, PhxDragHandleComponent],
  imports: [CommonModule, FormsModule, DragDropModule, PhxIconButtonModule, PhxIconModule],
  exports: [PhxDropListComponent, PhxDragItemComponent, PhxDragItemCardComponent, PhxDragItemInlineComponent, PhxDragHandleComponent],
})
export class PhxDragAndDropModule {}
